import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb49bc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_2 = { class: "col-8" }
const _hoisted_3 = { class: "accounts-item__info" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "accounts-item__info-block" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-4 row justify-content-end align-items-center" }
const _hoisted_8 = { class: "accounts-item__balance" }
const _hoisted_9 = { class: "accounts-item__detail-info" }
const _hoisted_10 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Available")
], -1))
const _hoisted_12 = { class: "col-3 row justify-content-end" }
const _hoisted_13 = { class: "col-3 row justify-content-end" }
const _hoisted_14 = { class: "col-3 row justify-content-end" }
const _hoisted_15 = {
  key: 0,
  class: "accounts-item__detail-info"
}
const _hoisted_16 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Staked")
], -1))
const _hoisted_18 = { class: "col-3 row justify-content-end" }
const _hoisted_19 = { class: "col-3 row justify-content-end" }
const _hoisted_20 = { class: "col-3 row justify-content-end" }
const _hoisted_21 = {
  key: 1,
  class: "accounts-item__detail-info"
}
const _hoisted_22 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Unbonding")
], -1))
const _hoisted_24 = { class: "col-3 row justify-content-end" }
const _hoisted_25 = { class: "col-3 row justify-content-end" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-end" }, null, -1))
const _hoisted_27 = {
  key: 2,
  class: "accounts-item__detail-info"
}
const _hoisted_28 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Redeemable")
], -1))
const _hoisted_30 = { class: "col-3 row justify-content-end" }
const _hoisted_31 = { class: "col-3 row justify-content-end" }
const _hoisted_32 = { class: "col-3 row justify-content-end" }
const _hoisted_33 = {
  key: 3,
  class: "accounts-item__detail-info"
}
const _hoisted_34 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Vested")
], -1))
const _hoisted_36 = { class: "col-3 row justify-content-end" }
const _hoisted_37 = { class: "col-3 row justify-content-end" }
const _hoisted_38 = { class: "col-3 row justify-content-end" }
const _hoisted_39 = {
  key: 0,
  class: "accounts-item__detail-info-ends"
}
const _hoisted_40 = {
  key: 4,
  class: "accounts-item__detail-info"
}
const _hoisted_41 = { class: "row justify-content-beetwen align-items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Reserved")
], -1))
const _hoisted_43 = { class: "col-3 row justify-content-end" }
const _hoisted_44 = { class: "col-3 row justify-content-end" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-3 row justify-content-end" }, null, -1))

import { computed, PropType, ref } from "vue";
import BaseButton from "@/components/base-button/index.vue";
import Expand from "@/icons/common/expand.vue";
import { Account } from "@/types/account";
import { Token } from "@/types/token";
import { Balance } from "@/types/balance";
import VueCountdown from "@chenfengyuan/vue-countdown";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'accounts-item',
  props: {
  account: {
    type: Object as PropType<Account>,
    default: () => ({}),
  },
  isLast: {
    type: Boolean,
    default: false,
  },
  balance: {
    type: Object as PropType<Balance>,
    default: undefined,
  },
  token: {
    type: Object as PropType<Token>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const isOpen = ref<boolean>(false);



const toggle = () => {
  isOpen.value = !isOpen.value;
};

const valuesBreakdown = computed(() => {
  const numAvailable = props.balance?.available?.toNumber() || 0;
  const numStaked = props.balance?.staked?.toNumber() || 0;
  const numUnbonding = props.balance?.unbonding?.toNumber() || 0;
  const numRedeemable = props.balance?.redeemable?.toNumber() || 0;
  const numVested = props.balance?.vested?.toNumber() || 0;
  const numReserved = props.balance?.reserved?.toNumber() || 0;

  return {
    available: {
      balance: numAvailable,
      usdValue: numAvailable * (props.token?.price?.toNumber() || 0),
    },
    staked: {
      balance: numStaked,
      usdValue: numStaked * (props.token?.price?.toNumber() || 0),
    },
    unbonding: {
      balance: numUnbonding,
      usdValue: numUnbonding * (props.token?.price?.toNumber() || 0),
    },
    redeemable: {
      balance: numRedeemable,
      usdValue: numRedeemable * (props.token?.price?.toNumber() || 0),
    },
    vested: {
      balance: numVested,
      usdValue: numVested * (props.token?.price?.toNumber() || 0),
    },
    reserved: {
      balance: numReserved,
      usdValue: numReserved * (props.token?.price?.toNumber() || 0),
    },
  };
});

const navigateToSend = () => {
  router.push({
    name: "send",
    query: {
      from: props.account.address,
    },
  });
};

const navigateToStake = () => {
  router.push({
    name: "stake",
  });
};

const navigateToUnbond = () => {
  router.push({
    name: "stake-unbond",
    query: {
      address: props.account.address,
    },
  });
};

const navigateToWithdraw = () => {
  router.push({
    name: "stake-withdraw",
    query: {
      address: props.account.address,
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["accounts-item container-inner", { last: __props.isLast }]),
      onClick: toggle
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: __props.account.image,
              alt: ""
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h3", null, [
                _createTextVNode(_toDisplayString(__props.account.name), 1),
                (__props.account.isLedger)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Ledger"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", null, _toDisplayString(_ctx.$filters.replaceWithEllipsis(
                  _ctx.$filters.formatAddress(__props.account.address),
                  6,
                  6
                )), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h3", _hoisted_8, [
            _createTextVNode(_toDisplayString(__props.balance === undefined
              ? "--"
              : _ctx.$filters.cryptoCurrencyFormat(__props.balance.total)) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
          ]),
          _createVNode(Expand, {
            class: _normalizeClass(["accounts-item__arrow", { open: isOpen.value }])
          }, null, 8, ["class"])
        ])
      ])
    ], 2),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["accounts-item__detail", { last: __props.isLast }])
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currencyFormat(
                  valuesBreakdown.value.available.usdValue,
                  "USD"
                )), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("h3", null, [
                  _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(valuesBreakdown.value.available.balance)) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(BaseButton, {
                  title: "Stake",
                  stroke: true,
                  small: true,
                  action: navigateToStake
                }),
                _createVNode(BaseButton, {
                  title: "Send",
                  stroke: true,
                  small: true,
                  action: navigateToSend
                })
              ])
            ])
          ]),
          (valuesBreakdown.value.staked.balance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currencyFormat(valuesBreakdown.value.staked.usdValue, "USD")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h3", null, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(valuesBreakdown.value.staked.balance)) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(BaseButton, {
                      title: "Unbond",
                      stroke: true,
                      small: true,
                      action: navigateToUnbond
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (valuesBreakdown.value.unbonding.balance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currencyFormat(
                  valuesBreakdown.value.unbonding.usdValue,
                  "USD"
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("h3", null, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(valuesBreakdown.value.unbonding.balance)) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
                    ])
                  ]),
                  _hoisted_26
                ])
              ]))
            : _createCommentVNode("", true),
          (valuesBreakdown.value.redeemable.balance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currencyFormat(
                  valuesBreakdown.value.redeemable.usdValue,
                  "USD"
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("h3", null, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(
                  valuesBreakdown.value.redeemable.balance
                )) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(BaseButton, {
                      title: "Withdraw",
                      stroke: true,
                      small: true,
                      action: navigateToWithdraw
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (valuesBreakdown.value.vested.balance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currencyFormat(valuesBreakdown.value.vested.usdValue, "USD")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("h3", null, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(valuesBreakdown.value.vested.balance)) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (__props.balance && __props.balance.vestingEndMillisecondsLeft)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                          _createVNode(_unref(VueCountdown), {
                            interval: 60000,
                            time: __props.balance.vestingEndMillisecondsLeft
                          }, {
                            default: _withCtx(({ days, hours, minutes }) => [
                              _createTextVNode(" Ends in" + _toDisplayString(`${days ? ` ${days}d` : ""}${
                    hours ? ` ${hours}h` : ""
                  } ${minutes}m`), 1)
                            ]),
                            _: 1
                          }, 8, ["time"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (valuesBreakdown.value.reserved.balance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$filters.currencyFormat(
                  valuesBreakdown.value.reserved.usdValue,
                  "USD"
                )), 1)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("h3", null, [
                      _createTextVNode(_toDisplayString(_ctx.$filters.cryptoCurrencyFormat(valuesBreakdown.value.reserved.balance)) + " ", 1),
                      _createElementVNode("span", null, _toDisplayString(__props.token?.symbol || "dot"), 1)
                    ])
                  ]),
                  _hoisted_45
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2), [
          [_vShow, isOpen.value]
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})